<template>
  <div class="container-fluid">
    <h2 class="title text-center">綠能公車亭智慧照明應用 - 顯示詳細資料</h2>
    <div class="row">

      <div class="col-12 d-flex justify-content-center mt-3">
        <b-button style="margin: 0 3px; color: white;" size="sm" variant="primary" @click="get_power_logs('today')">今天</b-button>
        <b-button style="margin: 0 3px; color: white;" size="sm" variant="primary" @click="get_power_logs('7day')">近七天</b-button>
        <b-button style="margin: 0 3px; color: white;" size="sm" variant="primary" @click="get_power_logs('1mon')">近一個月</b-button>
        <b-button style="margin: 0 3px; color: white;" size="sm" variant="primary" @click="get_power_logs('6mon')">近半年</b-button>
        <b-button style="margin: 0 3px; color: white;" size="sm" variant="primary" @click="get_power_logs('1year')">近一年</b-button>
      </div>
      <div class="col-12 d-flex justify-content-center">
        <history-mixed-chart :data="power_load_chart_data" :options="power_load_option"/>
      </div>
      <div class="col-12 d-flex justify-content-center mt-3">
        <history-mixed-chart :data="battery_chart_data" :options="battery_option"/>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config/global'
import io from 'socket.io-client'
import moment from 'moment-timezone'
import { hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import HistoryMixedChart from '@/views/HistoryMixedChart'

export default {
  components: {
    HistoryMixedChart
  },
  data() {
    let chart_tooltips = {
      enabled: false,
      custom: CustomTooltips,
      intersect: true,
      mode: 'index',
      position: 'nearest',
      callbacks: {
        labelColor: function (tooltipItem, chart) {
          return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
        }
      }
    };

    let chart_xaxes = [{
      scaleLabel: {
        display: true,
        labelString: '時間',
        fontColor: '#fff'
      },
      gridLines: {
        display: true,
        color: '#444',          // 柔和白色格線
        borderDash: [4, 4],     // 虛線
        drawBorder: true,
        zeroLineColor: '#fff',    // 0 軸線顏色（主線）
        zeroLineWidth: 3          // 0 軸線粗細
      },
      ticks: {
        fontColor: '#fff'            // 刻度字色
      }
    }];

    return {
      socket: null,
      start_time: null,
      end_time: null,
      power_load_chart_data: null,
      battery_chart_data: null,
      refresh_interval: 60000,//60sec
      refresh_time: null,
      history_data: {
        labels: ['2023-01', '2023-02', '2023-03'],      // X 軸標籤（時間、分類等）
        datasets: [                                     // 資料集（可以有多條線）
          {
            type: 'line',                               // 指定為曲線圖
            label: '負載輸出',                           // 圖例的名稱
            data: [10, 15, 7],                          // Y 軸數值（跟 labels 一一對應)
            yAxisID: 'output-axis',
            borderColor: hexToRgba('#A7DF93', 90),      // 折線顏色
            backgroundColor: hexToRgba('#A7DF93', 90),  // 點或填充區背景色
            fill: false,                              // 是否填滿線下區域
          },
          {
            type: 'bar',                             // 指定為長條圖
            label: '電池剩餘電力百分比',
            yAxisID: 'bettery-axis',
            data: [90, 80, 75],
            backgroundColor: hexToRgba('#1E90FF', 90),
            borderColor: hexToRgba('#1E90FF', 90),
            borderWidth: 1,
          }
        ]
      },
      power_load_option: {
        responsive: true,             //圖表會自動根據父元素大小調整寬高，適應不同螢幕
        maintainAspectRatio: true,    //預設會強制圖表維持原比例，設成 false 可以更自由改高寬
        tooltips: chart_tooltips,
        legend: {                     //設定圖例
          display: true,
          labels: {
            fontColor: '#fff',        //設定圖例（如「電池溫度」）的字體顏色
            //fontSize: 14,             // 字體大小
            //fontStyle: 'bold',        // 字體樣式（normal、italic、bold...）
            //boxWidth: 20              // 圖例前方小方塊寬度
          }
        },
        scales: {                     //控制 X 軸、Y 軸的標籤、格線、刻度等
          xAxes: chart_xaxes,
          yAxes: [
            {
              id: 'pv_power-axis',
              type: 'linear',
              position: 'left',
              scaleLabel: {
                display: true,      //顯示 Y 軸標題
                labelString: 'W',  //Y 軸標題文字
                fontColor: hexToRgba('#7CFC00', 90)
              },
              gridLines: {
                display: false,
                color: '#444',  // 柔和白色格線
                borderDash: [4, 4],                 // 虛線
                drawBorder: true,
                zeroLineColor: '#fff',    // 0 軸線顏色（主線）
                zeroLineWidth: 3          // 0 軸線粗細
              },
              ticks: {
                beginAtZero: true,          //Y 軸從 0 開始
                fontColor: hexToRgba('#7CFC00', 90),            // 刻度字色
                min: 0,
                max: 1000   // ✅ 設定固定最大值，讓兩軸比例一致
              }
            },
            {
              id: 'load_output-axis',
              type: 'linear',
              position: 'right',
              scaleLabel: {
                display: true,      //顯示 Y 軸標題
                labelString: 'W',  //Y 軸標題文字
                fontColor: hexToRgba('#FFA500', 90)
              },
              gridLines: {
                display: false,
                color: '#444',  // 柔和白色格線
                borderDash: [4, 4],                 // 虛線
                drawBorder: true,
                zeroLineColor: '#fff',    // 0 軸線顏色（主線）
                zeroLineWidth: 3          // 0 軸線粗細
              },
              ticks: {
                beginAtZero: true,    //Y 軸從 0 開始
                fontColor: hexToRgba('#FFA500', 90),            // 刻度字色
                min: 0,
                max: 1000   // ✅ 設定固定最大值，讓兩軸比例一致
              }
            }
          ]
        } 
      },
      battery_option: {
        responsive: true,             //圖表會自動根據父元素大小調整寬高，適應不同螢幕
        maintainAspectRatio: true,    //預設會強制圖表維持原比例，設成 false 可以更自由改高寬
        tooltips: chart_tooltips,
        legend: {                     //設定圖例
          display: true,
          labels: {
            fontColor: '#fff',        //設定圖例（如「電池溫度」）的字體顏色
            //fontSize: 14,             // 字體大小
            //fontStyle: 'bold',        // 字體樣式（normal、italic、bold...）
            //boxWidth: 20              // 圖例前方小方塊寬度
          }
        },
        scales: {                     //控制 X 軸、Y 軸的標籤、格線、刻度等
          xAxes: chart_xaxes,
          yAxes: [
            {
              id: 'soc-axis',
              type: 'linear',
              position: 'left',
              scaleLabel: {
                display: true,      //顯示 Y 軸標題
                labelString: '%',  //Y 軸標題文字
                fontColor: hexToRgba('#7CFC00', 90)
              },
              gridLines: {
                display: false,
                color: '#444',  // 柔和白色格線
                borderDash: [4, 4],                 // 虛線
                drawBorder: true,
                zeroLineColor: '#fff',    // 0 軸線顏色（主線）
                zeroLineWidth: 3          // 0 軸線粗細
              },
              ticks: {
                beginAtZero: true,          //Y 軸從 0 開始
                fontColor: hexToRgba('#7CFC00', 90),            // 刻度字色
                min: 0,
                max: 100   // ✅ 設定固定最大值，讓兩軸比例一致
              }
            },
            {
              id: 'soh-axis',
              type: 'linear',
              position: 'right',
              scaleLabel: {
                display: true,      //顯示 Y 軸標題
                labelString: '%',  //Y 軸標題文字
                fontColor: hexToRgba('#1E90FF', 90)
              },
              gridLines: {
                display: false,
                color: '#444',  // 柔和白色格線
                borderDash: [4, 4],                 // 虛線
                drawBorder: true,
                zeroLineColor: '#fff',    // 0 軸線顏色（主線）
                zeroLineWidth: 3          // 0 軸線粗細
              },
              ticks: {
                beginAtZero: true,    //Y 軸從 0 開始
                fontColor: hexToRgba('#1E90FF', 90),           // 刻度字色
                min: 0,
                max: 100   // ✅ 設定固定最大值，讓兩軸比例一致
              }
            }
          ]
        } 
      },
    };
  },
  mounted(){
    let app = this;
    this.get_power_logs('today');
  },
  beforeDestroy(){
    if(this.refresh_time) {
      clearTimeout(this.refresh_time);
    }
  },
  methods: {
    get_power_logs(range) {
      let app = this;

      switch(range){
        case '7day':
          app.end_time = moment().tz(config.timezone);
          app.start_time = moment().tz(config.timezone).subtract(7, 'days');
          break;
        case '1mon':
          app.end_time = moment().tz(config.timezone);
          app.start_time = moment().tz(config.timezone).subtract(1, 'month');
          break;
        case '6mon':
          app.end_time = moment().tz(config.timezone);
          app.start_time = moment().tz(config.timezone).subtract(6, 'month');
          break;
        case '1year':
          app.end_time = moment().tz(config.timezone);
          app.start_time = moment().tz(config.timezone).subtract(1, 'year');
          break;
        case 'test':
          app.end_time = moment.tz("2025-04-20 20:00:00", "YYYY-MM-DD HH:mm:ss", config.timezone);
          app.start_time = moment.tz("2025-04-20 20:00:00", "YYYY-MM-DD HH:mm:ss", config.timezone).subtract(1, 'days');
          break;
        default: //today
          app.end_time = moment().tz(config.timezone);
          app.start_time = moment().tz(config.timezone).subtract(1, 'days');
          break;
      }

      //console.info('app.start_time:', app.start_time.format('YYYY-MM-DD HH:mm:ss'));
      //console.info('app.end_time:', app.end_time.format('YYYY-MM-DD HH:mm:ss'));

      this.$jsonp(`${config.api_root}/get_power_logs`, {
        sn: encodeURIComponent(config.encrypt('ECO04-0001', config.ffkey, config.ffiv)),
        user_id: encodeURIComponent(3),
        start_time: app.start_time.format('YYYY-MM-DD HH:mm:ss'),
        end_time: app.end_time.format('YYYY-MM-DD HH:mm:ss')
      }, 5000).then((power_logs) => {
        
        //console.info('power_logs:', power_logs);

        let duration = moment.duration(app.end_time.diff(app.start_time));

        duration = Math.ceil(duration.asDays());

        let group_str = 'YYYY/MM/DD';

        if(duration <= 1){
          group_str = 'MM/DD HH:mm';
        } else if (duration >= 7 && duration <= 92) {
          group_str = 'MM/DD';
        } else if (duration >= 92 && duration <= 366) {
          group_str = 'MM';
        } else if (duration >= 366 ) {
          group_str = 'YYYY';
        }

        //format data
        let labels       = [];
        let pv_total_set = [];
        let load_pwr_set = [];
        let bat_soc_set = [];
        let bat_soh_set = [];

        //let battery_bank1_temp_set = [];
        //let battery_bank1_volt_set = [];
        //let battery_bank1_curr_set = [];

        power_logs.forEach((log) => {
          let idstr = moment(log.id_str, 'YYYY/MM/DD HH:mm:ss');

          labels.push(idstr.format(group_str));
          pv_total_set.push(parseFloat(log.pv_total_power).toFixed(1));
          load_pwr_set.push(parseFloat(log.load_output_pwr).toFixed(1));
          bat_soc_set.push(parseFloat(log.battery_soc).toFixed(1));
          bat_soh_set.push(parseFloat(log.battery_soh).toFixed(1));

          //battery_bank1_temp_set.push(parseFloat(log.battery_bank1_temp).toFixed(1));
          //battery_bank1_volt_set.push(parseFloat(log.battery_bank1_volt).toFixed(1));
          //battery_bank1_curr_set.push(parseFloat(log.battery_bank1_curr).toFixed(1));
        });

        // 更新 Y 軸最大值(左軸和右軸)
        const max_pv_power = pv_total_set.length > 0 ? Math.max(...pv_total_set) : 1000;
        //console.info('max_pv_power:', max_pv_power);
        const max_load_pwr = load_pwr_set.length > 0 ? Math.max(...load_pwr_set) : 1000;
        //console.info('max_load_pwr:', max_load_pwr);
        const unifiedMax = Math.ceil(Math.max(max_pv_power, max_load_pwr) / 10) * 10;
        //console.info('unifiedMax:', unifiedMax);
        this.power_load_option.scales.yAxes.forEach(axis => {
          axis.ticks.min = 0;
          axis.ticks.max = unifiedMax;
        });

        // 呼叫 chart 更新
        //this.$refs.myChart.chart.update();

        // console.info('labels:', labels);
        // console.info('pv_total_set:', pv_total_set);

        app.power_load_chart_data = {
          labels,      // X 軸標籤（時間、分類等）
          datasets: [                                     // 資料集（可以有多條線）
            {
              type: 'line',                               // line:曲線圖 bar:長條圖
              label: '太陽能發電',                           // 圖例的名稱
              yAxisID: 'pv_power-axis',
              data: pv_total_set,                          // Y 軸數值（跟 labels 一一對應)
              borderColor: hexToRgba('#7CFC00', 90),      // 折線顏色
              backgroundColor: hexToRgba('#7CFC00', 90),  // 點或填充區背景色
              fill: false,                              // 是否填滿線下區域
            },
            {
              type: 'line',                             // line:曲線圖 bar:長條圖
              label: '負載輸出',
              yAxisID: 'load_output-axis',
              data: load_pwr_set,
              backgroundColor: hexToRgba('#FFA500', 90),
              borderColor: hexToRgba('#FFA500', 90),
              fill: false,
            }
          ]
        };

        app.battery_chart_data = {
          labels,      // X 軸標籤（時間、分類等）
          datasets: [                                     // 資料集（可以有多條線）
            {
              type: 'line',                             // line:曲線圖 bar:長條圖
              label: '電池健康度',
              yAxisID: 'soh-axis',
              data: bat_soh_set,
              backgroundColor: hexToRgba('#1E90FF', 90),
              borderColor: hexToRgba('#1E90FF', 90),
              fill: false,                              // 是否填滿線下區域
            },
            {
              type: 'line',                               // line:曲線圖 bar:長條圖
              label: '電池剩餘電力百分比',                           // 圖例的名稱
              yAxisID: 'soc-axis',
              data: bat_soc_set,                          // Y 軸數值（跟 labels 一一對應)
              borderColor: hexToRgba('#7CFC00', 90),      // 折線顏色
              backgroundColor: hexToRgba('#7CFC00', 90),  // 點或填充區背景色
            },
          ]
        }
      });
    },//eo get_records
    Refresh(device){
      if(device){

      }
    },
    RefreshTimer(){
      //let app = this;
      if(this.refresh_time) {
        clearTimeout(this.refresh_time);
        this.refresh_time = null;
      }

      /*this.$jsonp(`${config.api_root}/ReadPower`, {
        sn: encodeURIComponent(config.encrypt('ECO04-0001', config.ffkey, config.ffiv)),
        user_id: encodeURIComponent(3),
      }, 5000).then((result) => {
        //console.info('result:', result);
        if(result.success){
          this.Refresh(result.device);
        }
      });*/

      this.refresh_time = setTimeout(() => {
        this.RefreshTimer();
      }, this.refresh_interval);
    },
  }
};
</script>
  
<style>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;  /* 讓 `.container` 佔滿父層 */
  max-width: 100vw;
  height: 80vh;
  background-color: black;
  color: white; /* 文字變白 */
  position: relative;
}

/* 標題樣式 */
.title {
  font-size: 28px; /* 放大標題 */
  font-weight: bold;
  margin-bottom: 10px;
  color: #fff;
}

.subtitle {
  font-size: 18px; /* 放大副標題 */
  color: gray;
  margin-bottom: 20px;
}

/* 確保圖表容器寬度自適應 */
.chart-container {
  width: 100%;
  max-width: 100%; /* 防止圖表超出容器 */
}
</style>
  